// extracted by mini-css-extract-plugin
export default {"modal_title":"styles_modal_title__sE8Pe"};